import React from 'react';
import { Star } from 'lucide-react';

/**
 * ReviewStars — mostra le stelle (1-5).
 *
 * Props:
 *   rating      number   — valore 1-5 (supporta decimali per la media)
 *   size        'xs'|'sm'|'md'  — default 'sm'
 *   showValue   boolean  — se mostrare il numero accanto alle stelle
 *   count       number   — se passato, mostra "(N recensioni)"
 */
const SIZE_MAP = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
};

const ReviewStars = ({ rating = 0, size = 'sm', showValue = false, count }) => {
  const cls = SIZE_MAP[size] || SIZE_MAP.sm;
  const filled = Math.round(rating);

  return (
    <span className="inline-flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={cls}
          fill={i <= filled ? '#f59e0b' : 'none'}
          stroke={i <= filled ? '#f59e0b' : '#cbd5e1'}
        />
      ))}
      {showValue && (
        <span className="ml-1 text-xs font-semibold text-slate-600">
          {Number(rating).toFixed(1)}
        </span>
      )}
      {count !== undefined && (
        <span className="ml-1 text-xs text-slate-400">
          ({count} {count === 1 ? 'recensione' : 'recensioni'})
        </span>
      )}
    </span>
  );
};

// Audit 2026-09-20, punto #14: React.memo, stesso motivo di CarCard.js.
export default React.memo(ReviewStars);
